module.exports = __webpack_public_path__ + "img/icon-close.1fdafc33.svg";